import HomePage from "./home.tsx";

export default {
  path: "/",
  Component: HomePage,
};
